function redirect() {
  const urlParams = new URLSearchParams(window.location.search);
  const referralCode = urlParams.get("referralCode");

  const userAgent = navigator?.userAgent?.toLowerCase();
  
  if (/iphone|ipad|ipod/.test(userAgent)) {
    window.location.replace(
      "https://apps.apple.com/us/app/homeal/id1571860810"
    );
    return null;
  } else {
    window.location.replace(
      referralCode !== null ?  `https://play.google.com/store/apps/details?id=com.localzi.homeal&referrer=utm_source=${referralCode}&utm_medium=awesome-med&utm_campaign=awesome-campaign`
      : "https://play.google.com/store/apps/details?id=com.localzi.homeal"
    );
    return null; 
  } 
}

export default redirect;